import { render, staticRenderFns } from "./deliveryRecord.vue?vue&type=template&id=4c0df62b&scoped=true&"
import script from "./deliveryRecord.vue?vue&type=script&lang=js&"
export * from "./deliveryRecord.vue?vue&type=script&lang=js&"
import style0 from "./deliveryRecord.vue?vue&type=style&index=0&id=4c0df62b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0df62b",
  null
  
)

export default component.exports